import usePath from '../../../components/Hooks/usePath';
import LoadingPage from '../../../components/LoadingPage/LoadingPage';
import { usePublicApplication } from '../../../hooks/usePublicApplication';
import LangEnum from '../../../lang/LangEnum';
import PATHS from '../../../routes/routes.const';
import NotFoundPage from '../../errors/pages/NotFoundPage/NotFoundPage';

const ValidatePage = ({ children }: { children: JSX.Element }) => {
  const { sharedEntity, sharedEntityLoading } = usePublicApplication();
  const { isPath } = usePath();
  const isPublicPath = isPath(PATHS.public.catalog.path) || isPath(PATHS.public.order.path);

  if (sharedEntityLoading && isPublicPath) {
    return <LoadingPage backgroundless />;
  }

  if (!sharedEntity && isPublicPath) {
    return (
      <NotFoundPage
        hasHomeAction={false}
        title={LangEnum.ORDER_CONTRACT_404_ERROR_TITLE}
        description={LangEnum.ORDER_CONTRACT_404_ERROR_MESSAGE}
      />
    );
  }

  return children;
};

export default ValidatePage;
